import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Loader } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api';
import { authHeader } from '../auth';

const Page = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #eef2ff 0%, #e0f2fe 100%);
  padding: 2rem 1rem;
`;

const Card = styled.div`
  width: 100%;
  max-width: 520px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.15);
  padding: 2rem;
  text-align: center;
`;

const Title = styled.h1`
  font-size: 1.4rem;
  font-weight: 800;
  color: #111827;
  margin-bottom: 0.75rem;
`;

const Text = styled.p`
  font-size: 0.95rem;
  color: #4b5563;
`;

const BillingSuccess = () => {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const check = async () => {
      try {
        const res = await api.get('/api/user/premium', { headers: authHeader() });
        if (res.data?.is_premium) {
          navigate('/app');
          return;
        }
      } catch {
        // ignore and send to login below
      } finally {
        setChecking(false);
      }
    };

    check();
  }, [navigate]);

  if (!checking) {
    navigate('/login');
    return null;
  }

  return (
    <Page>
      <Card>
        <Loader size={28} className="animate-spin" />
        <Title>Odeme kontrol ediliyor</Title>
        <Text>Premium durumun dogrulaniyor, lutfen bekleyin.</Text>
      </Card>
    </Page>
  );
};

export default BillingSuccess;
